<template>
  <div class="float-right">
    <div v-if="show">
      <b-spinner small />
    </div>
    <div v-else>
      <h3
        id="popover-balance"
        class="text-danger text-right"
        @click="hidePopover"
      >
        <small
          class="text-dark font-weight"
          style="font-size: 18px"
        >Balance:</small>
        {{ balance }}
      </h3>
      <div v-if="valor_uso > 0">
        <div v-if="resumen">
          <code
            style="font-size: 17px"
          >Balance: {{ balance }} + Calculo [{{ dia_uso }}]:
            {{ valor_uso }} = {{ total }}</code>
        </div>
        <div v-else>
          <b-popover
            ref="popover-balance"
            target="popover-balance"
            triggers="hover"
            placement="auto"
          >
            <template #title>
              Desglose de Valores
            </template>
            <li>
              <span>Balance: {{ balance }}</span>
            </li>
            <li>
              <span>Calculo [{{ dia_uso }}]: {{ valor_uso }}</span>
            </li>
            <li>
              <span>Total: {{ total }}</span>
            </li>
          </b-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BPopover, BSpinner } from "bootstrap-vue"

export default {
  components: {
    BSpinner,
    BPopover,
  },
  props: {
    idcontrato: {
      type: Number,
      required: true,
    },
    resumen: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      show: true,
      balance: 0,
      total: 0,
      valor_uso: 0,
      dia_uso: 0,
    }
  },
  created() {
    this.searchBalance()
  },
  methods: {
    searchBalance() {
      if (this.idcontrato > 0) {
        this.$http
          .get("/contrato-balance", {
            params: {
              idcontrato: this.idcontrato,
              idusuario: this.userData.id,
              opresumen: 1,
            },
          })
          .then((response) => {
            this.show = false
            if (response.data) {
              this.balance = response.data.data
              this.total = response.data.total
              this.valor_uso = response.data.valor_uso
              this.dia_uso = response.data.dia_uso
            }
          })
          .catch(function (error) {
            this.show = false
            console.log(error)
          })
      }
    },
    hidePopover() {
      this.$root.$emit("bv::hide::popover-balance", "popover-balance")
    },
  },
}
</script>

<style></style>
